import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ORIENTATION, SPACING } from '../../constants';

const StepLine = ({
  orientation = ORIENTATION.vertical,
  gap = SPACING.spacingM,
  withDecoration = true,
  children,
}) => {
  const stepLineClassNames = classNames(
    'ws-ui-step-line',
    `ws-ui-step-line--${orientation}`,
    `ws-ui-step-line--${gap}`,
    {
      'ws-ui-step-line--with-decoration': withDecoration,
    }
  );

  return <div className={stepLineClassNames}>{children}</div>;
};

StepLine.propTypes = {
  orientation: PropTypes.oneOf(Object.values(ORIENTATION)),
  gap: PropTypes.oneOf(Object.values(SPACING)),
  withDecoration: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default StepLine;
